import { email } from 'util/validation'
import { uniq } from 'util/arrays'
import { doCreateInvitation } from 'actions/invitations'

import { COMPLETED_PAGE } from '../pages'

import { SWITCH_INPUT_MODE, INVITATION_ERROR } from './types'

export function doSwitchInputMode() {
  return {
    type: SWITCH_INPUT_MODE,
  }
}

export function doSingleInputFormSubmit(form) {
  return (dispatch, getState) => {
    const emails = [
      form.emailAddress0Input,
      form.emailAddress1Input,
      form.emailAddress2Input,
    ]
    return doSubmitSignup(emails)(dispatch, getState)
  }
}

export function doMultiInputFormSubmit(form) {
  return (dispatch, getState) => {
    const emails = form.multiEmailAddressInput.split('\n')
    return doSubmitSignup(emails)(dispatch, getState)
  }
}

export function doSubmitSignup(emails) {
  return (dispatch, getState) => {
    return Promise.all(
      uniq(emails.filter(e => email(e) === null)).map(e =>
        doCreateInvitation({
          agentType: 'helpdesk_kb',
          email: e,
        })(dispatch, getState)
      )
    )
      .then(responses => {
        const errors = responses.filter(r => r.success === false)
        if (errors.length > 0) {
          dispatch({
            type: INVITATION_ERROR,
            payload: {
              errors: errors.map(
                error => `Unable to invite ${error.email}, please try again`
              ),
            },
          })
        } else {
          dispatch({
            type: COMPLETED_PAGE,
          })
        }
        return responses
      })
      .catch(error => {
        dispatch({
          type: INVITATION_ERROR,
          payload: { errors: [error] },
        })
      })
  }
}
